export default "__VITE_ASSET__9IuEORuW__"